const MMP_PAGE_SELECTOR = "#MainContent[data-template='product.merowen-macrame']";
const MMP_ROOT_SELECTOR = '[data-merowen-macrame-product-section="details"]';
const MMP_CONTACT_ROOT_SELECTOR = '[data-merowen-macrame-product-section="contact"]';
const MMP_INSTANCES = new WeakMap();
const MMP_CONTACT_INSTANCES = new WeakMap();

function setAccordionDefaults(root) {
  const isDesktop = window.matchMedia('(min-width: 1100px)').matches;
  const isMobile = window.matchMedia('(max-width: 767px)').matches;

  root.querySelectorAll('[data-merowen-macrame-product-accordion]').forEach((details) => {
    if (details.dataset.userToggled === 'true') return;
    details.open = (isDesktop && details.hasAttribute('data-open-desktop'))
      || (isMobile && details.hasAttribute('data-open-mobile'));
  });
}

function initDetails(root) {
  if (!root || MMP_INSTANCES.has(root)) return;

  const onToggle = (event) => {
    const details = event.target.closest('[data-merowen-macrame-product-accordion]');
    if (details) details.dataset.userToggled = 'true';
  };
  const onResize = () => setAccordionDefaults(root);

  root.addEventListener('toggle', onToggle, true);
  window.addEventListener('resize', onResize, { passive: true });
  setAccordionDefaults(root);

  MMP_INSTANCES.set(root, () => {
    root.removeEventListener('toggle', onToggle, true);
    window.removeEventListener('resize', onResize);
    MMP_INSTANCES.delete(root);
  });
}

function initContact(root) {
  if (!root || MMP_CONTACT_INSTANCES.has(root)) return;

  const form = root.querySelector('[data-merowen-macrame-product-contact-form]');
  const message = root.querySelector('[data-merowen-macrame-product-contact-message]');
  const count = root.querySelector('[data-merowen-macrame-product-contact-count]');
  const submit = root.querySelector('[data-merowen-macrame-product-contact-submit]');
  const success = root.querySelector('[data-merowen-macrame-product-contact-success]');

  if (!form) return;

  const updateCount = () => {
    if (!message || !count) return;
    count.textContent = `${message.value.length} / ${message.maxLength}`;
  };

  const updateError = (input) => {
    const field = input.closest('.merowen-macrame-product__contact-field');
    const error = field?.querySelector('[data-merowen-macrame-product-contact-error]');
    if (!error) return;

    const invalid = !input.validity.valid;
    error.textContent = invalid ? input.validationMessage : '';
    error.classList.toggle('is-visible', invalid);
    if (invalid) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  };

  const onInvalid = (event) => {
    if (!event.target.matches('[data-merowen-macrame-product-contact-input]')) return;
    updateError(event.target);
  };

  const onInput = (event) => {
    if (event.target === message) updateCount();
    if (event.target.matches('[data-merowen-macrame-product-contact-input]')) updateError(event.target);
  };

  const onSubmit = () => {
    if (!form.checkValidity() || !submit) return;
    submit.disabled = true;
    submit.setAttribute('aria-disabled', 'true');
  };

  form.addEventListener('invalid', onInvalid, true);
  form.addEventListener('input', onInput);
  form.addEventListener('submit', onSubmit);
  updateCount();

  if (success) requestAnimationFrame(() => success.focus());

  MMP_CONTACT_INSTANCES.set(root, () => {
    form.removeEventListener('invalid', onInvalid, true);
    form.removeEventListener('input', onInput);
    form.removeEventListener('submit', onSubmit);
    MMP_CONTACT_INSTANCES.delete(root);
  });
}

function initWithin(scope = document) {
  const page = scope.matches?.(MMP_PAGE_SELECTOR) ? scope : scope.querySelector?.(MMP_PAGE_SELECTOR);
  const searchRoot = page || scope;
  searchRoot.querySelectorAll?.(MMP_ROOT_SELECTOR).forEach(initDetails);
  searchRoot.querySelectorAll?.(MMP_CONTACT_ROOT_SELECTOR).forEach(initContact);
}

function destroyWithin(scope) {
  if (!scope) return;
  const roots = scope.matches?.(MMP_ROOT_SELECTOR)
    ? [scope]
    : Array.from(scope.querySelectorAll?.(MMP_ROOT_SELECTOR) || []);

  roots.forEach((root) => MMP_INSTANCES.get(root)?.());

  const contactRoots = scope.matches?.(MMP_CONTACT_ROOT_SELECTOR)
    ? [scope]
    : Array.from(scope.querySelectorAll?.(MMP_CONTACT_ROOT_SELECTOR) || []);

  contactRoots.forEach((root) => MMP_CONTACT_INSTANCES.get(root)?.());
}

initWithin();

document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
document.addEventListener('shopify:block:select', (event) => {
  const block = event.target;
  if (!block?.closest?.(MMP_ROOT_SELECTOR)) return;
  block.scrollIntoView({ behavior: 'smooth', block: 'center' });
});
